import React from "react";

import Web3Img from "../../assets/img/services/web3/web3.png";

function Web3() {
  return (
    <div>
      <div className="flex flex-col h-full items-center">
        <div className="flex flex-col lg:flex-row w-[80%] m-auto mt-28">
          <div className="w-full lg:w-1/2">
            <img src={Web3Img} alt="" className="m-auto sm:w-[60%] mb-10" />
          </div>
          <div className="flex items-center justify-center md:w-[80%]">
            <div className="block">
              <div className="text-left lg:w-[20rem] sm:w-[15rem] font-bold text-[14px] lg:text-[24px] text-white md:text-left uppercase mb-5 sm:px-8">
                ENTERPRISE LEVEL WEB3 IMPLEMENTATION
              </div>
              <div>
                <p className=" text-white sm:text-[14px] sm:text-left md:text-left break-words lg:w-[88%] mb-5 text-xs md:text-lg sm:px-8">
                  Web3 is the next major phase in the evolution of the internet.
                  Web3 focuses on decentralization, scalability, data security,
                  and privacy of users.
                </p>
                <div className="w-full flex flex-col relative">
                  <div
                    className="container rounded-[13px] border border-solid border-white sm:pt-[56.25%] pt-[40%] -left-12 -top-8 scale-[0.8] sm:left-0 sm:w-full sm:-top-4"
                    style={{ background: "rgba(12,16,69,0.38)" }}
                  >
                    <iframe
                      width="562"
                      height="313"
                      src="https://www.youtube.com/embed/l44z35vabvA"
                      title="What Exactly is Web3? by Juan Benet at Web3 Summit 2018"
                      className="p-[0.8rem] responsive-iframe"
                    >
                      {""}
                    </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 className="fixed -left-8 -bottom-[21%] sm:-bottom-[29%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] scale-[0.8] sm:scale-[0.7] sm:-left-20 sm: h2Mobile md:block hidden">
        DECENTRALIZE
      </h2>
    </div>
  );
}

export default Web3;
